export const ACTIVE_SPEAKER_TUNING_DEFAULTS = {
    minAudioLevel: 0.02,
    switchDwellMs: 150,
    minDisplayMs: 300,
    switchMargin: 0,
    currentLevelHoldMs: 250,
};
function clampActiveSpeakerTuningNumber(value, fallback, min, max) {
    const numberValue = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(numberValue))
        return fallback;
    return Math.min(max, Math.max(min, numberValue));
}
export function normalizeActiveSpeakerTuning(input = {}) {
    return {
        minAudioLevel: clampActiveSpeakerTuningNumber(input.minAudioLevel, ACTIVE_SPEAKER_TUNING_DEFAULTS.minAudioLevel, 0, 1),
        switchDwellMs: Math.round(clampActiveSpeakerTuningNumber(input.switchDwellMs, ACTIVE_SPEAKER_TUNING_DEFAULTS.switchDwellMs, 0, 5000)),
        minDisplayMs: Math.round(clampActiveSpeakerTuningNumber(input.minDisplayMs, ACTIVE_SPEAKER_TUNING_DEFAULTS.minDisplayMs, 0, 10000)),
        switchMargin: clampActiveSpeakerTuningNumber(input.switchMargin, ACTIVE_SPEAKER_TUNING_DEFAULTS.switchMargin, 0, 1),
        currentLevelHoldMs: Math.round(clampActiveSpeakerTuningNumber(input.currentLevelHoldMs, ACTIVE_SPEAKER_TUNING_DEFAULTS.currentLevelHoldMs, 0, 5000)),
    };
}
//# sourceMappingURL=events.types.js.map